"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _style = require("webmotors-react-pj/webinput/select/style");
var _customAttributes = _interopRequireDefault(require("webmotors-react-pj/webinput/custom-attributes"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = exports.default = (0, _react.forwardRef)((props, ref) => {
  const {
    children = [],
    onChange,
    value,
    placeholder,
    maxItems = Math.min(props.children && props.children.length, 5),
    id = "webinput_select_".concat(+new Date()),
    width = '200px'
  } = props;
  const [open, setOpen] = (0, _react.useState)(false);
  const [selectText, setSelectText] = (0, _react.useState)();
  const [selectValue, setSelectValue] = (0, _react.useState)(value);
  const [selectItems, setSelectItems] = (0, _react.useState)(children);
  const [selectHeight, setSelectHeight] = (0, _react.useState)(maxItems);
  const selectInput = (0, _react.useRef)() || ref;
  const propsCustom = (0, _customAttributes.default)(props, 'options|maxItems|value');
  const handleOpen = () => {
    setOpen(true);
  };
  const handleChange = e => {
    setSelectValue(e.target.value);
    onChange && onChange(e);
  };
  const handleSelectItem = e => {
    const {
      target
    } = e;
    setSelectValue(target.dataset.value || '');
    setSelectText(target.textContent);
    setOpen(false);
  };
  const forceClose = () => {
    window.addEventListener('click', e => {
      if (!e.target.closest('[data-inputselect]')) {
        setOpen(false);
      }
    });
  };
  const renderPlaceholder = () => placeholder && _react.default.createElement(_style.StylePlaceholder, null, placeholder);
  (0, _react.useEffect)(() => {
    forceClose();
    const child = [];
    const childAppend = item => {
      const {
        value: optionValue
      } = item.props;
      const {
        children: optionContent
      } = item.props;
      child.push(_react.default.createElement(_style.StyleOptionsItem, {
        key: optionValue || +new Date(),
        "data-value": optionValue,
        onClick: e => handleSelectItem(e)
      }, optionContent));
    };
    children.forEach(item => {
      if (item && item.props) {
        childAppend(item);
      }
      if (item.constructor.name === 'Array') {
        item.forEach(itemArray => childAppend(itemArray));
      }
    });
    const {
      selectedOptions
    } = selectInput.current;
    const [selectedOptionsText] = selectedOptions;
    setSelectText(selectedOptionsText && selectedOptionsText.textContent);
    setSelectItems(child);
    setSelectHeight(Math.min(child.length, 5));
  }, [children]);
  (0, _react.useEffect)(() => {
    setTimeout(() => setSelectValue(value), 10);
  }, [value]);
  (0, _react.useEffect)(() => {
    const {
      current
    } = selectInput;
    Object.getOwnPropertyDescriptor(window.HTMLSelectElement.prototype, 'value').get.call(current);
    const event = new Event('change', {
      bubbles: true
    });
    current.dispatchEvent(event);
    setTimeout(() => {
      const {
        selectedOptions
      } = current;
      let textContent = '';
      if (selectedOptions && selectedOptions[0]) {
        textContent = selectedOptions[0].textContent;
      }
      setSelectText(textContent);
    }, 10);
  }, [selectValue]);
  return _react.default.createElement(_style.StyleWrapper, {
    "data-inputselect": true
  }, _react.default.createElement(_style.StyleSelect, (0, _extends2.default)({}, propsCustom, {
    ref: selectInput,
    value: selectValue,
    onChange: e => handleChange(e)
  }), children), _react.default.createElement(_style.StyleContent, {
    width: width,
    "data-value": selectValue
  }, renderPlaceholder(), _react.default.createElement(_style.StyleItemCurrent, {
    onClick: () => handleOpen()
  }, _react.default.createElement(_style.StyleItemName, null, selectText), _react.default.createElement(_style.StyleItemIcon, {
    viewBox: "0 0 24 24",
    xmlns: "https://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M21.0004 8.00012C21.0004 8.25612 20.9024 8.51212 20.7074 8.70712L12.7074 16.7071C12.3164 17.0981 11.6844 17.0981 11.2934 16.7071L3.29337 8.70712C2.90237 8.31612 2.90237 7.68412 3.29337 7.29312C3.68437 6.90212 4.31637 6.90212 4.70737 7.29312L12.0004 14.5861L19.2934 7.29312C19.6844 6.90212 20.3164 6.90212 20.7074 7.29312C20.9024 7.48812 21.0004 7.74412 21.0004 8.00012Z"
  }))), _react.default.createElement(_style.StyleOptions, {
    open: open
  }, _react.default.createElement(_style.StyleOptionsContent, {
    maxItems: selectHeight
  }, selectItems))));
});